/*
 * clarity-consent.js — lädt Microsoft Clarity NUR nach Analytics-Einwilligung.
 *
 * Warum im Theme: Die Microsoft-Clarity-Shopify-App bindet Clarity als App-Pixel mit
 * Berechtigung „immer ausgeführt" ein → Clarity lädt/sendet dann UNABHÄNGIG vom Consent
 * (auch nach „Ablehnen", cookielos aber aufzeichnend). Für DE (DSGVO + TDDDG §25) muss vor
 * der Einwilligung nichts geladen/gesendet werden. Deshalb: App entfernen, Clarity hier
 * consent-gated selbst laden.
 *
 * Hooks: theme-eigenes 'consent:updated' (assets/consent.js, detail={analytics,marketing,…})
 *        + Shopifys 'visitorConsentCollected'. Projekt-ID aus settings.clarity_project_id
 *        (data-hm-clarity am Script-Tag). Leer → Loader tut nichts.
 *
 * Clarity Consent Mode v2: nach dem Laden MUSS 'consentv2' gesendet werden, sonst bliebe
 * Clarity im EEA-Default 'denied' (cookielos) trotz Zustimmung.
 */
(function () {
  'use strict';

  var self = document.querySelector('script[data-hm-clarity]');
  var CLARITY_ID = self ? (self.getAttribute('data-hm-clarity') || '').trim() : '';
  if (!CLARITY_ID) return;

  var loaded = false;

  function privacy() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  function allowed(fn) {
    var p = privacy();
    try { return !!(p && typeof p[fn] === 'function' && p[fn]()); }
    catch (e) { return false; }
  }

  // Clarity kann während der Übergangsphase (Clarity-App noch installiert) bereits
  // präsent sein → dann NICHT ein zweites Mal injizieren.
  function clarityScriptPresent() {
    return !!document.querySelector('script[src*="clarity.ms/tag/"]');
  }

  function loadClarity() {
    if (loaded) return;
    loaded = true;
    if (clarityScriptPresent()) return; // schon da (App) → keine Doppel-Ladung
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_ID);
  }

  function signalGranted(marketing) {
    if (typeof window.clarity !== 'function') return;
    try {
      window.clarity('consentv2', {
        ad_Storage: marketing ? 'granted' : 'denied',
        analytics_Storage: 'granted'
      });
    } catch (e) {}
  }

  function stopClarity() {
    // Zustimmung mittendrin widerrufen → Clarity stoppen + Cookies löschen.
    if (typeof window.clarity === 'function') {
      try { window.clarity('consent', false); } catch (e) {}
    }
  }

  function apply(ev) {
    // Bevorzugt die Booleans aus dem consent:updated-Event, sonst die Privacy-API.
    var d = (ev && ev.detail && typeof ev.detail.analytics === 'boolean') ? ev.detail : null;
    var analytics = d ? !!d.analytics : allowed('analyticsProcessingAllowed');
    var marketing = d ? !!d.marketing : allowed('marketingAllowed');

    if (analytics) {
      loadClarity();
      if (typeof window.clarity === 'function') { signalGranted(marketing); }
      else { setTimeout(function () { signalGranted(marketing); }, 300); }
    } else if (loaded) {
      stopClarity();
    }
  }

  // Consent-Änderungen (Banner-Aktion / anderer Tab) → sofort reagieren.
  document.addEventListener('consent:updated', apply);
  document.addEventListener('visitorConsentCollected', apply);

  // Initiale Auswertung (z. B. wiederkehrende Besucher mit bestehender Zustimmung).
  function start() {
    if (privacy()) { apply(); return true; }
    return false;
  }
  if (!start()) {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function () { apply(); }
      );
    } else {
      var n = 0;
      var iv = setInterval(function () {
        if (start() || ++n > 40) clearInterval(iv);
      }, 250);
    }
  }
})();
